var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flix-bg-info flix-text-center",staticStyle:{"padding":"10px"}},[_c('div',{staticClass:"flix-overflow"},[_c('div',{staticClass:"flex flex-center"},[_c('nextAppointmentsCalendar',{attrs:{"filter":_vm.filter}})],1),_c('holidayCalendar')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }